export default {
      id: "i-chart-histogram-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/sprite.svg#i-chart-histogram",
      toString: function () {
        return this.url;
      }
    }